import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from 'projects/apex/src/app/components/translate/translate.module';
import { SelectOnFocusModule } from '../../directives/select-on-focus/select-on-focus.module';
import { InputDialogComponent } from './input-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    TranslateModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,

    SelectOnFocusModule,
  ],
  declarations: [InputDialogComponent],
  exports: [InputDialogComponent],
})
export class InputDialogModule {}
